// src/components/Layout/PageHeader.jsx
import React from "react";

const PageHeader = ({
  eyebrow,
  title,
  subtitle,
  align = "center",
  size = "lg",
  className = "",
}) => {
  const isCenter = align === "center";

  // Taille du titre selon le contexte
  let titleSizeClasses = "text-2xl sm:text-3xl md:text-4xl";
  if (size === "md") titleSizeClasses = "text-2xl md:text-3xl";
  if (size === "sm") titleSizeClasses = "text-xl md:text-2xl";

  return (
    <div className={`w-full ${className}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`${isCenter ? "text-center" : "text-left"} mb-6 md:mb-8`}>
          {eyebrow && (
            <p className="text-xs font-semibold tracking-[0.35em] uppercase text-primary mb-1">
              {eyebrow}
            </p>
          )}

          {title && (
            <h1
              className={`${titleSizeClasses} font-extrabold tracking-tight font-montserrat uppercase`}
            >
              {title}
            </h1>
          )}

          {subtitle && (
            <p
              className={`mt-3 text-sm md:text-base text-slate-600 dark:text-slate-300 max-w-2xl ${
                isCenter ? "mx-auto" : ""
              }`}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
